import { keepPreviousData, useQuery } from '@tanstack/react-query';

import type {
  ListQueryParams,
  ServiceCategoriesListResponseData,
} from '@/types/api/queries';

import { HttpClient } from '@/network/HttpClient';

export const SERVICE_CATEGORIES_LIST_QUERY_KEY = 'service_categories_list';

export const useServiceCategoriesListQuery = (
  url: string,
  queryParams: ListQueryParams,
) =>
  useQuery({
    queryKey: [SERVICE_CATEGORIES_LIST_QUERY_KEY, url, queryParams],
    queryFn: () =>
      HttpClient.request<ServiceCategoriesListResponseData>({
        method: 'GET',
        url,
        params: queryParams,
      }),
    refetchOnWindowFocus: false,
    placeholderData: keepPreviousData,
  });
